import script from "./SalaryCap.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryCap.vue?vue&type=script&setup=true&lang=js"

import "./SalaryCap.vue?vue&type=style&index=0&id=181e77f0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181e77f0"]])

export default __exports__